import { useEffect } from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';
import {
  useChromeConfigurationListenerWithCallback,
  useIsFeatureEnabled,
} from 'src/commons/hooks';
import { ChromeConfigurationChangeEvent } from 'src/commons/types';
import { WeblabedFeatures } from '../constants';
import { logger } from './logger';

export const ChromeConfigCaptureUrlPatterns = [
  /\/cm.*/i,
  /\/campaign-manager.*/i,
  /\/rta\/dashboard.*/i,
  /\/ads\/dashboard.*/i,
  /\/ads\/campaigns.*/i,
  /\/cb\/sp.*/i,
  /\/cb\/sb.*/i,
  /\/dsp.*/i,
];

export const isUrlQualifiedForChromeConfigCapture = (url: string): boolean => {
  const pathname = new URL(url).pathname;
  for (const re of ChromeConfigCaptureUrlPatterns) {
    if (re.test(pathname)) {
      return true;
    }
  }
  return false;
};

export const captureChromeConfig = (
  config,
  isChromeConfigCaptureEnabled: boolean,
) => {
  const currentUrl = window.location.href;

  if (
    isChromeConfigCaptureEnabled &&
    isUrlQualifiedForChromeConfigCapture(currentUrl)
  ) {
    // note the interface of the logger object. We can log an object in the second param
    logger.info('Chrome configuration logged', {
      url: currentUrl,
      'Captured Chrome Config': config,
    });
  }
};

const useCaptureChromeConfig = (): void => {
  const isChromeConfigCaptureEnabled = useIsFeatureEnabled(
    WeblabedFeatures.AAC_Chrome_Config_Capture,
  );
  // log config on mount
  useEffect(() => {
    captureChromeConfig(
      AACChromeAPI.getChromeConfiguration(),
      isChromeConfigCaptureEnabled,
    );
  }, []);

  // log when config changes
  useChromeConfigurationListenerWithCallback(
    (event: ChromeConfigurationChangeEvent) => {
      const newConfig = event.detail.chromeConfiguration;
      captureChromeConfig(newConfig, isChromeConfigCaptureEnabled);
    },
  );
};

export default useCaptureChromeConfig;
